import { offsetPaginationWithMaxLimitSchema } from '@crowdfpl/domain/pagination';
import { teamEntitySchema } from '@crowdfpl/domain/team';
import { z } from 'zod';

export const TeamSchema = teamEntitySchema;

export const TeamsListResponseSchema = z.object({
  teams: z.array(TeamSchema),
  pagination: offsetPaginationWithMaxLimitSchema,
});

export type TeamDto = z.infer<typeof TeamSchema>;
export type TeamsListResponse = z.infer<typeof TeamsListResponseSchema>;
